import {
  createElementObject,
  createLayerComponent,
  extendContext,
  type EventedProps,
} from "@react-leaflet/core";
import type L from "leaflet";
import type { ReactNode } from "react";
import { CanvasPinMarker } from "../utils/canvasPin/CanvasPinMarker";
import type { CanvasPinIcon } from "../utils/canvasPin/CanvasPinIcon";
import type { CanvasPinRenderer } from "../utils/canvasPin/CanvasPinRenderer";
import { updateCanvasPin } from "../utils/canvasPin/updateCanvasPin";

export interface CanvasPinProps extends EventedProps {
  position: L.LatLngExpression;
  icon: CanvasPinIcon;
  /** 選択中（ポップアップを開いている間）の見た目 */
  selectedIcon?: CanvasPinIcon;
  /** 重ねる段（PIN_DRAW_LEVEL） */
  drawLevel?: number;
  /** 地図で共有するレンダラ（getSharedCanvasPinRenderer） */
  renderer: CanvasPinRenderer;
  /** <Popup> など。react-leaflet の Marker と同じくピンに結び付く */
  children?: ReactNode;
}

/**
 * react-leaflet の Marker の代わりに使う、Canvas に描くピン。
 * 子の <Popup> はピンに bindPopup され、ref には CanvasPinMarker が入る。
 */
export const CanvasPin = createLayerComponent<CanvasPinMarker, CanvasPinProps>(
  function createCanvasPin(
    { position, icon, selectedIcon, drawLevel, renderer },
    ctx
  ) {
    const marker = new CanvasPinMarker(position, {
      icon,
      selectedIcon,
      drawLevel,
      renderer,
    });
    return createElementObject(
      marker,
      extendContext(ctx, { overlayContainer: marker })
    );
  },
  updateCanvasPin
);
